const urlEnd = '/';
export default urlEnd;